import i18n from "i18next";
import { resolveLocalized } from "@repo/i18n/localized-string.js";
import { useTailorabilityStore } from "@/store/tailorability.store";
import { useTheme } from "@/lib/theme.jsx";
import sgrcText from "@/assets/sgrc-text.png";
import sgrcTextDark from "@/assets/sgrc-text-dark.png";
import sgrcLogo from "@/assets/sgrc-logo.png";
import sgrcLogoDark from "@/assets/sgrc-logo-dark.png";

export function useBrandMarkAssets() {
    const { theme } = useTheme();
    const branding = useTailorabilityStore((s) => s.branding);
    const isDark = theme === "dark";
    const defaultLogo = isDark ? sgrcLogoDark : sgrcLogo;
    const defaultText = isDark ? sgrcTextDark : sgrcText;
    const language = (i18n.resolvedLanguage || i18n.language || "tr").split("-")[0];
    const productLabel = resolveLocalized(branding?.appName, language) || null;
    const useWordmarkImage = !productLabel || /^sgrc$/i.test(String(productLabel).trim());

    return {
        defaultLogo,
        defaultText,
        logoSrc: branding?.logoUrl || defaultLogo,
        productLabel,
        useWordmarkImage,
    };
}
